<template>
  <div class="row">
    <div class="col-lg-8 col-lg-offset-2 col-xs-12">
        <CreditInfo v-if="renderInfo" />
    </div>

    <div class="col-md-6 col-md-offset-3 col-xs-12 m-t-30" v-if="loader === 'table'">
      <h3 class="ce"> {{text_response}}</h3>
      <div class="ce" v-if="download"> {{lead_search}} </div>
      <div style="overflow: auto">
        <table>
        <tr>
            <th>Field</th>
            <th>Value</th>
        </tr>
        <tr v-for="(value, propertyName, index) in lead" v-bind:key="index" v-if="value">
            <td>{{propertyName}}</td>
            <td>{{value}}</td>
        </tr>

        </table>
      </div>
      <div class="col-md-6 m-t-10" v-if="download">
          <download-csv
              class   = "btn btn-large bold box"
              :data   = "[lead]"
              :name    = "file_name">

              Download (.csv)

          </download-csv>
      </div>
      <div class="col-md-6 m-t-10 col-xs-12" v-if="!download">
          <button class="btn btn-large bold" @click="modalState(true)"> Buy credits </button>
      </div>
      <div class="col-md-6 m-t-10 col-xs-12">
          <button class="btn btn-large bold" @click="resetSearch"> New search </button>
      </div>
    </div>

    <div class="col-xl-12 col-xs-12 vcenter" v-if="loader !== 'table'">
      <div class="form-middle-lookup" v-if="loader === 'false'">
        <div class="title-form">
            <h2>More than just another email finder.</h2>
            <span> Find contact info with just a social media profile, email, or phone number. </span>
        </div>
        <div>
          <div class="w-form">
            <div class="row">
                <div class="col-md-12 col-xl-12">
                    <flash-message></flash-message>
                    <form @submit.prevent="goLookup">
                        <div class="col-md-12">
                            <div class="field">
                                <input type="text" v-model="search" placeholder="https://www.linkedin.com/in/marcbenioff/" class="input-form" required>
                                <label for="email">Search lead</label>
                            </div>
                        </div>

                        <div class="dotted-content-loads">
                          <div class="checkboxes">
                            <p><strong>Optional:</strong> enrich lead record only if <span  class="signo" :title="title_orbitly">&#63;</span> </p>
                            <div class="box-ul">
                              {{required}}
                              <ul>
                                <li><input v-model="email" type="checkbox" :checked="email"> email is available </li>
                                <li><input v-model="phone" type="checkbox" :checked="phone"> phone is available </li>
                                <li><input v-model="profile" type="checkbox" :checked="profile"> profiles is available </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-12 m-t-10">
                            <input type="submit" value="Find email and social profiles" class="btn btn-large bold">
                        </div>
                    </form>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-middle-lookup" v-if="loader === 'true'">
        <span> Searching our records for {{search || $route.query.lookup}} </span>
        <div class="spinner">
            <div class="double-bounce1"></div>
            <div class="double-bounce2"></div>
        </div>
      </div>

      <div class="form-middle-lookup" v-if="loader === '404'">
        <div class="ce">
            <h3> Could not find record for</h3>
            <div>{{search || $route.query.lookup}}</div>
            <button class="btn btn-smallbold ce m-t-50" @click="resetSearch"> New search </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreditInfo from '@/components/CreditInfo.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'login',
  components: {
    CreditInfo
  },
  mounted () {
    this.messageStorage.destroyAll()
    this['user/setLookup'](false)
    var d = new Date()
    var lookup = this.$route.query.lookup
    this.file_name = d.getMonth() + '-' + d.getDay() + '-' + d.getFullYear() + '-' + d.getTime() + '.csv'
    if (lookup) {
      // this.messageStorage.flash('', 'success')
      this.searchLead(lookup)
    } else {
      this.loader = 'false'
    }
  },
  data () {
    return {
      search: '',
      loader: 'false',
      title_orbitly: 'Enabling this option allows you to require email, phone, or both data fields. \n \n Requiring email or phone ensures you are charged only for records that can be enriched with these data fields. \n \n If email or phone is unavailable for a record, Orbitly will skip the contact.',
      lead_search: '',
      phone: false,
      profile: false,
      required: '',
      email: false,
      text_response: '',
      file_name: 'file_name.csv',
      download: false,
      lead: {},
      renderInfo: true,
      messageStorage: this.flash()
    }
  },
  methods: {

    ...mapMutations([
      'user/setAuthUser',
      'user/setLookup',
      'uploadedLeadList/modalState',
      'uploadedLeadList/changeUpdateInfo'
    ]),

    modalState (value) {
      this.renderInfo = false
      this.$nextTick(() => {
        this.renderInfo = true
      })
      this['uploadedLeadList/modalState'](value)
      this['uploadedLeadList/changeUpdateInfo'](false)
    },

    goLookup: function () {
      this.searchLead(this.search)
      this.$router.push({ name: 'lookup', query: { lookup: this.search } })
    },

    resetSearch: function () {
      this.loader = 'false'
      this.$router.push({ name: 'lookup' })
    },

    searchLead: function (lookup) {
      var d = new Date()
      this.loader = 'true'
      this.$http.get('/api/leads/search', { params: { email: this.email, phone: this.phone, profile: this.profile, lookup: lookup } }).then((res) => {
        // console.log(res)
        this.lead = res.data
        this.search = ''
        this.loader = 'table'
        this.download = true
        this.text_response = 'Record found for'
        this.lead_search = lookup
        if (res.data.first_name && res.data.last_name) {
          this.file_name = res.data.first_name + '_' + res.data.last_name + '_' + d.getTime() + '.csv'
        } else {
          this.file_name = d.getMonth() + '-' + d.getDay() + '-' + d.getFullYear() + '-' + d.getTime() + '.csv'
        }
        if (res.data['orbitly_credits_used'] === 1) {
          var data = this.user_data
          data['credits'] = data['credits'] - 1
          this['user/setAuthUser'](data)
        }
      }).catch((err) => {
        this.search = ''
        if (err.status === 402) {
          this.lead = err.data
          this.loader = 'table'
          this.modalState(true)
          this.text_response = 'Record found, but you need more credits!'
        } else {
          this.loader = '404'
        }
      })
    }
  },
  computed: {
    user_data: function () {
      return this.$store.state.user.data
    }
  }
}

</script>

<style lang="scss" scoped>

.dotted-content-loads {
    text-align: center;
    vertical-align: middle;
}

.ce {
    text-align: center;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}

.box {
  display: block;
  box-sizing: border-box;
  text-align: center;
}
</style>
